import { Link } from '@tanstack/react-router';
import { Logo, useSeasonalLogo } from '@uturn/ui-kit';

export const HeaderLogo = ({ linkTo = '/shipments' }: { linkTo?: string }) => {
	const { variant: logoVariant, isSeasonal } = useSeasonalLogo();

	return (
		<Link to={linkTo}>
			{isSeasonal ? (
				<Logo variant={logoVariant} className="-mt-5 h-12 w-auto" />
			) : (
				<Logo className="-mt-1 h-7 w-auto" />
			)}
		</Link>
	);
};
